"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSweetAlert = void 0;
const react_redux_1 = require("react-redux");
const show_1 = require("../actions/show");
const hide_1 = require("../actions/hide");
const useSweetAlert = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const show = (config) => dispatch((0, show_1.sweetAlertShow)(config));
    const showError = (config) => dispatch((0, show_1.sweetAlertErrorShow)(config));
    const showSuccess = (config) => dispatch((0, show_1.sweetAlertSuccessShow)(config));
    const update = (config) => dispatch((0, show_1.sweetAlertUpdate)(config));
    const hide = () => dispatch((0, hide_1.sweetAlertHide)());
    return {
        show,
        showError,
        showSuccess,
        update,
        hide,
    };
};
exports.useSweetAlert = useSweetAlert;
